module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0103.jpg?v=bbe70779";